import { useMutation } from "@apollo/client";
import {
  DELETE_COMPETITION,
  GET_COMPETITIONS,
  COMPETITIONS_WITH_PERMISSION,
} from "../../GraphQL/Competitions";
import useNotification from "../../hooks/useNotification.js";
import ConfirmDeleteDialog from "../UI/ConfirmDeleteDialog.js";

const DeleteCompetitionDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [deleteCompetition, { loading, error }] = useMutation(DELETE_COMPETITION, {
    variables: { id: props.competition.id },
    refetchQueries: [GET_COMPETITIONS, COMPETITIONS_WITH_PERMISSION],
    onCompleted: () => {
      notifySuccess("Competition deleted.");
      props.setOpen(false);
    },
  });

  return (
    <ConfirmDeleteDialog
      open={props.open}
      setOpen={props.setOpen}
      entityName={props.competition.name}
      onConfirm={deleteCompetition}
      loading={loading}
      error={error}
      confirmTestId="saveDeleteCompetitionDialogButton"
      cancelTestId="closeDeleteCompetitionDialogButton"
    />
  );
};

export default DeleteCompetitionDialog;
